import React from 'react';
import Avatar from "../../../components/Avatar";
import {handicaddieSelector} from "../../../services/store/asyncThunk";
import Button from "../../../components/Button";
import Container from "../../../components/Container";
import {useNavigate} from "react-router-dom";
import {buildUrl, PLATFORM_EDIT_PROFILE} from "../../../services/PageUtils";

interface Props {

}

const ProfileHeader = ({}: Props) => {

    const { user, userAvatar } = handicaddieSelector((state) => state.session)

    const nav = useNavigate()

    const goToEditProfile = () => {
        nav(buildUrl(PLATFORM_EDIT_PROFILE))
    }

    return (
        <Container>
            <div className={"profileHeader"}>
                <span className={"profileHeader_welcome"}>Welcome back,</span>

                <div className={"profileHeader_userDetails"}>
                    <Avatar url={userAvatar} size={'smd'} style={{ alignSelf: 'center' }} />

                    <div>
                        <p>{user?.displayName}</p>
                        {/*<StarRating rating={3.8} />*/}
                        <div style={{ marginTop: '16px' }}>
                            <Button text={"Edit Profile"} variant={'primary'} onClick={goToEditProfile} slim />
                        </div>
                    </div>
                </div>
            </div>
        </Container>
    )
}

export default ProfileHeader;